import {createAsyncThunk} from '@reduxjs/toolkit'
import {
  FetchClasseByIdRequest,
  UpdateClasseRequest,
  FetchClassesRequest,
  CreateClasseRequest,
  DeleteClasseRequest,
  SuspendClasseRequest,
  ActivateClasseRequest,
  FetchAllClassesRequest,
} from './types'
import {AxiosError} from 'axios'
import {ResponseError} from '../commonTypes'
import {Classe} from '../../../models'
import axios from 'axios'
import {
  fetchClassesUrl,
  fetchClasseByIdUrl,
  createClasseUrl,
  updateClasseUrl,
  deleteClasseUrl,
  suspendClasseUrl,
  activateClasseUrl,
  fetchAllClassesUrl,
} from '../../api'

export const fetchClasses = createAsyncThunk(
  'classe/fetch',
  async (payload: FetchClassesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchClassesUrl}?sortField=${payload.sortField}&sortOrder=${
          payload.sortOrder
        }&pageNumber=${payload.pageNumber}&pageCount=${payload.pageCount}${
          typeof payload.isFinished === 'boolean' ? '&isFinished=' + payload.isFinished : ''
        }${
          payload.search && payload.search.trim() !== '' ? '&search=' + payload.search.trim() : ''
        }`
      )
      const {classes, totalPages, total} = res.data
      return {
        classes,
        totalPages,
        total,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchAllClasses = createAsyncThunk(
  'classe/fetchAll',
  async (payload: FetchAllClassesRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${fetchAllClassesUrl}${
          typeof payload.isFinished === 'boolean' ? '?isFinished=' + payload.isFinished : ''
        }`
      )
      const {classes} = res.data
      return {
        classes,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const fetchClasseById = createAsyncThunk(
  'classe/fetchById',
  async (payload: FetchClasseByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${fetchClasseByIdUrl}/${payload.id}`)
      const {classe} = res.data
      return {
        classe,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const createClasse = createAsyncThunk(
  'classe/create',
  async (payload: CreateClasseRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(createClasseUrl, payload)
      const {classe} = res.data
      return {
        classe,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const updateClasse = createAsyncThunk(
  'classe/update',
  async (payload: UpdateClasseRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(updateClasseUrl, payload)
      const {classe} = res.data
      return {
        classe,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const deleteClasse = createAsyncThunk(
  'classe/delete',
  async (payload: DeleteClasseRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(deleteClasseUrl, payload)
      const {classe} = res.data
      return {
        classe,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const suspendClasse = createAsyncThunk(
  'classe/suspend',
  async (payload: SuspendClasseRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(suspendClasseUrl, payload)
      const {classe} = res.data
      return {
        classe,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)

export const activateClasse = createAsyncThunk(
  'classe/activate',
  async (payload: ActivateClasseRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(activateClasseUrl, payload)
      const {classe} = res.data
      return {
        classe,
        success: true,
      }
    } catch (error) {
      const err: any = error as AxiosError
      const message = err.response?.data.fr
      return rejectWithValue({
        success: false,
        error: message || 'message',
      })
    }
  }
)
